import { useDispatch, useSelector } from 'react-redux';
import noop from 'utils/noop';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/modal';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { PrimaryButton } from 'ui/button';
import { selectOrganizationId } from 'core/userContext';
import { useValidatedDomain } from '../hooks';
import { createDeepLinkPathRequest } from '../actions';
import { getIsLoading } from '../selectors';
import { EMPTY_APPLINKS_JSON } from '../constants';
// import { AppSiteAssociations, TrackingDomain } from '../types';

// type ModalProps = {
//   appAssociationSites: Array<AppSiteAssociations>;
//   trackingDomainName: TrackingDomain['domain'];
//   onClose: () => void;
// };

export const CreateDeepLinkPathModal = ({
  appAssociationSites = [],
  trackingDomainName = '',
  onClose = noop,
}) => {
  const dispatch = useDispatch();
  const [appDomain, setAppDomain, errorMessage] = useValidatedDomain(
    '',
    appAssociationSites,
    'appDomain',
  );
  const organizationId = useSelector(selectOrganizationId);
  const isLoading = useSelector(getIsLoading);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      createDeepLinkPathRequest(appDomain, trackingDomainName, organizationId, EMPTY_APPLINKS_JSON),
    );
    onClose();
  };

  const hasValidationError = errorMessage.length > 0;
  const isDisabled = hasValidationError || isLoading || appDomain.length === 0;

  return (
    <Modal
      id="createDeepLinkPathModal"
      isModalOpen
      data-test="mailDomains-create-deep-link-path-modal"
      onClose={onClose}
    >
      <ModalHeader>Create a new destination domain</ModalHeader>
      <ModalBody>
        <form id="createNewDestinationDomain" onSubmit={handleSubmit}>
          <FormField
            errorText={errorMessage}
            hasError={hasValidationError}
            inputId="mailDomains-create-deep-link-path-modal-form"
            isRequired
            key="newTrackingDomain"
            labelText="Destination domain"
          >
            <InputText
              autoFocus
              data-test="mailDomains-create-deep-link-url-form-input"
              hasError={hasValidationError}
              id="newTrackingDomain"
              onChange={(value) => setAppDomain(value)}
              placeholder="path.domain.com"
              required
              value={appDomain}
            />
          </FormField>
        </form>
      </ModalBody>
      <ModalFooter hasCancel onClose={onClose}>
        <PrimaryButton
          isDisabled={isDisabled}
          type="submit"
          key="submit"
          form="createNewDestinationDomain"
          data-test="mailDomains-create-deep-link-path-modal-confirm-button"
        >
          Create
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
